var collapsible_list_pair_rtlignore_default = {
  "container": "iElt3",
  "title": "r3TZx",
  "viewerContainer": "mbfIx",
  "titleContainer": "Nvsvp",
  "expandIcon": "_4uHUM",
  "dndIcon": "d3HPC",
  "RTL": "_9O6h4",
  "LTR": "jxjQI",
  "itemContainer": "_7o046",
  "itemContainerViewer": "pqSIw",
  "mouseDown": "Y3R8C",
  "innerEditor": "bsfCI",
  "item": "vft-j",
  "floatingAddPluginMenuWrapper": "_53od7",
  "childrenHidden": "PnpFv"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
